<script lang="ts" setup>
  import { computed } from 'vue';
  import type { SongSubmissionScore } from '../../../../shared/api/round.ts';

  const props = defineProps<{ songSubmissionScores: SongSubmissionScore[] }>();

  const countOf = (scoreType: SongSubmissionScore['scoreType']) =>
    props.songSubmissionScores.filter((score) => score.scoreType === scoreType).length;

  const correctGuessers = computed(() => countOf('correct'));
  const partiallyCorrectGuessers = computed(() => countOf('partially-correct'));
  const guessers = computed(() => props.songSubmissionScores.length - 1);
</script>

<template>
  <div class="correct-guess-count">
    <span class="stats-value">{{ correctGuessers }}/{{ guessers }}</span>
    <span class="stats-label">
      {{ correctGuessers === 1 ? 'player' : 'players' }} guessed correctly
      <span v-if="partiallyCorrectGuessers > 0" class="partial-subtext">
        ({{ partiallyCorrectGuessers }} {{ partiallyCorrectGuessers === 1 ? 'player was' : 'players were' }} partially
        correct)
      </span>
    </span>
  </div>
</template>

<style scoped>
  .correct-guess-count {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    text-align: center;
  }

  .stats-value {
    color: var(--color-primary);
    font-family: var(--font-logo);
    font-size: var(--font-size-2xl);
    line-height: 1;
  }

  .stats-label {
    color: var(--color-text-secondary);
    font-size: var(--font-size-md);
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .partial-subtext {
    color: var(--color-text-muted);
    display: block;
    font-size: var(--font-size-xs);
    letter-spacing: normal;
    margin-top: 0.1rem;
    text-transform: none;
  }
</style>
